import * as React from 'react';
import { withTranslation } from '@sailor/i18n-mach-pro';
import { FullDiscountExtraInfo, SpuExtraInfo } from '@/shop/c_shop_golden/component';
import './index.css';

interface IProps {
  // source: number,
  // shopId: string,
  // multiSkuModel: MultiSkuModel,
  // goodDetailData: GoodDetailData,
  // couponTips?: CouponTips,
  // originPrice: GoodDetailMinPrice;
  // discountPrice: GoodDetailMinPrice;
  extraInfo?: SpuExtraInfo;
  fullDiscountExtraInfo: FullDiscountExtraInfo;
  onClickBottomToastShow: Function;
  // onClickToShopPreview?: VoidFunction;

}

class DiscountTips extends React.Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
  }

  onClickToShopPreview = () => {

  }

  render() {
    // @ts-ignore
    const { fullDiscountExtraInfo, onClickBottomToastShow, extraInfo: { themeColor, backgroundColor = 'linear-gradient(179deg, #FFFBD9 7%, #FFF8AD 91%)' } = {} } = this.props;
    return (
      <view className="discount-tips-wrapper">
        <view
          className="coupon-tips-container" style={{ background: backgroundColor }} onClick={() => {
            //空实现，防止点击事件透传至上层
          }}
        >
          <view className="coupon-tips-container-inner">
            <image className="icon" src={fullDiscountExtraInfo?.fullDiscountTipsIconFront} />
            <text className="coupon-tips-text" content={fullDiscountExtraInfo?.fullDiscountTips} style={{ color: themeColor }} />
            {
              fullDiscountExtraInfo?.fullDiscountTipsIconLast
                ? (
                  <view className="icon-wrapper" onClick={() => { onClickBottomToastShow(); }}>
                    <image className="icon" src={fullDiscountExtraInfo?.fullDiscountTipsIconLast} />
                  </view>
                ) : null
            }
          </view>

        </view>
      </view>
    );
  }
}

export default withTranslation('', {
  withRef: true,
})(DiscountTips);
